import { DartfishNotebookProperties } from './DartfishNotebookProperties';

export class DartfishNotebookParser {
  constructor(private delimiter = ';') {}

  public parse(input: string): DartfishNotebookProperties[] {
    const props: DartfishNotebookProperties[] = [];
    const lines = input.split(/\n/);

    const nameColumn = 0;
    const positionColumn = 1;
    const durationColumn = 2;
    const periodColumn = 3;
    const actionColumn = 4;
    const colorTagColumn = 5;

    /* skip title row */
    for (let i = 1; i < lines.length; i++) {
      const row = lines[i].split(/[\;]/);
      const prop: DartfishNotebookProperties = {
        Name: row[nameColumn],
        Position: parseInt(row[positionColumn], 10),
        Duration: parseInt(row[durationColumn], 10),
        Period: row[periodColumn],
        Action: row[actionColumn],
        ColorTag: row[colorTagColumn]
      };

      props.push(prop);
    }

    return props;
  }
}
